import React, { useEffect, useRef, useMemo, useState } from "react";
//-----------------------Header-Footer-----------------------//
import Footer from "./Components/Footer";
import Header from "./Components/Header";
//-----------------------Images-----------------------//
import cardimg1 from "../assets/images/logo/Registration.svg";
import cardimg2 from "../assets/images/logo/Contact.svg";
import cardimg3 from "../assets/images/logo/Checked-User-Male.svg";
import cardimg4 from "../assets/images/logo/Denied.svg";
import excelfile from "../assets/images/logo/excel.svg";
import check from "../assets/images/check.svg";
import allrequest from "../assets/images/allrequest.svg";
import inProgress from "../assets/images/inprogress.svg";

import eye from "../assets/images/Eye.svg";
import { BsEye, BsFileEarmarkXFill, BsPersonFillDown } from "react-icons/bs";
import noFile from "../assets/images/noFile.svg";
import editImage from "../assets/images2/editColored.svg";
import editImagedisable from "../assets/images2/editDisable.svg";
import searchimg from "../assets/images2/Search.svg";
import filterSvg from "../assets/images2/filter.svg";
import closeModal from "../assets/images/CloseModel.svg";
import { FaSort, FaUserClock } from "react-icons/fa";
//-----------------------Reuseable-----------------------//
import Routes from "./Components/data/remote/Routes";
import "../index.css";
import "../App.css";

//-----------------------Libiraries-----------------------//
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DataTable from "react-data-table-component";
import Modal from "react-modal";
import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { Puff } from "react-loader-spinner";
import { toast, ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import { Tooltip } from "react-tooltip";
import { UnAuthModal } from "../reuseable/UnAuthModal";
import { checkAuth } from "../reuseable/UnAuthFunction";

const customSortIcon = (sortDirection) => {
  if (sortDirection === "asc") {
    return <FaSort className="" />;
  } else if (sortDirection === "desc") {
    return <FaSort className="" />;
  } else {
    return null;
  }
};

const formatWeekDay = (date) => {
  const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S"];
  return daysOfWeek[date.getDay()];
};

const ImrList = () => {
  const navigate = useNavigate();

  //states
  const [visible, setVisible] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showIcon, setShowIcon] = useState([]);
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const dropdownRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [requestType, setRequestType] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [page3, setPage3] = useState(0);
  const [perPage3, setPerPage3] = useState(10);
  const [selectedSkill, setSelectedSkill] = useState("");
  const [dropdownSearchValue, setDropdownSearchValue] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [disablefields, setDisableFields] = useState(false);
  const [disablefields2, setDisableFields2] = useState(false);
  const [showTableTwo, setShowTableTwo] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editedRow, setEditedRow] = useState(null);
  const [selectedRow2, setSelectedRow2] = useState(null);
  const [editedRow2, setEditedRow2] = useState(null);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editingRowId2, setEditingRowId2] = useState(null);
  const [selectedMaterialCode, setSelectedMaterialCode] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedShortText, setSelectedShortText] = useState(null);
  const [selectedOption3, setSelectedOption3] = useState(null);
  const [data, setData] = useState([]);
  const [isOpen3, setIsOpen3] = useState(false);

  const userID = secureLocalStorage.getItem("userLevel");
  const accessToken = secureLocalStorage.getItem("token");

  //custom sorting Method
  const handleSort = (column, sortDirection) => {
    setSortColumn(column.selector);
    setSortDirection(sortDirection);
  };

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  useEffect(() => {
    checkAuth();

    if (!accessToken) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    checkAuth();

    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  const notify = (message, type) => {
    // alert('error', +message)
    type == "success"
      ? toast.success(message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        })
      : toast.error(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
  };
  // close model method
  const handleCloseModal = () => {
    setIsOpen(false);
    notify("The Request IMR, ASR-1000001 has been cancelled ", "success");
  };

  const handleCloseModal2 = () => {
    setIsOpen(false);
  };

  const handleClick = (value, action, row) => {
    navigate("/view-imr", {
      state: { myBooleanValue: value, action: action, data: row },
    });
  };
  // dataTable columns
  const columns2 = [
    {
      id: 1,
      name: "Serial No",
      sortable: true,
      selector: (row, index) => page3 * perPage3 + index + 1,
    },
    {
      id: 2,
      name: "Project",
      selector: (row) => row?.projects?.project_name,
      sortable: true,
    },
    {
      id: 3,
      name: "IMR No",
      selector: (row) => row?.request_number,
      sortable: true,
    },
    {
      id: 4,
      name: "IMR Date",
      selector: (row) => moment(row?.created_at).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      id: 5,
      name: "Released by",
      selector: (row) =>
        row?.released_by
          ? `${row.released_by.first_name} ${row.released_by.last_name}`
          : "",
      sortable: true,
    },
    {
      id: 6,
      name: "Acting as",
      selector: (row) => row?.role,
      sortable: true,
    },
    {
      id: 7,
      name: "Released Date",
      selector: (row) =>
        row?.released_date
          ? dayjs(row?.released_date).format("DD-MM-YYYY")
          : "",

      sortable: true,
    },
    {
      id: 8,
      name: "Required Delivery Date",
      selector: (row) =>
        row?.material?.delivary_date
          ? dayjs(row.material.delivary_date).format("DD-MM-YYYY")
          : "No date found",
      sortable: true,
    },
    {
      id: 9,
      name: "Attachments",
      selector: (row) =>
        row?.document?.name ? row?.document?.name : "No attachments",
      sortable: true,
      cell: (row) =>
        row?.document?.name ? (
          <a
            data-tooltip-content="Preview Image"
            className="my-element"
            href={row?.document?.url}
            download
            target="_blank"
          >
            {row?.document?.name}
          </a>
        ) : (
          <p className="noAttachment">No attachments</p>
        ),
    },
    {
      id: 10,
      name: "Status",
      selector: (row) => row?.stage,
      sortable: true,
    },
    {
      id: 11,
      name: "Quick Action",
      cell: (row) => (
        <>
          <div className="d-flex">
            <div className="col">
              <img
                onClick={() => handleClick(1, 1, row)}
                data-tooltip-content="Preview Request"
                className="editImageIcon my-element"
                src={eye}
                alt="eye"
              />
            </div>
            <div className="col">
              {/* {row.projects.status == "1" ? (
                <img
                  onClick={() => setIsOpen(true)}
                  data-tooltip-content="Cancel Request"
                  className="editImageIcon ms-1 my-element"
                  src={noFile}
                  alt="trash"
                />
              ) : ( */}
              <BsFileEarmarkXFill
                className="my-element"
                data-tooltip-content="This feature will be implement in second phase"
                fontSize={"20px"}
                color="#e0dfdc"
              />
              {/* <img src={noFile} className="ms-1" disabled alt="trash" /> */}
              {/* )} */}
            </div>
            <div className="col">
              {row.projects.status == "1" ? (
                <EditButton
                  row={row}
                  editingRowId={editingRowId}
                  handleEditClick={handleEditClick}
                />
              ) : (
                <EditButton
                // row={row}
                // editingRowId={editingRowId}
                // handleEditClick={handleEditClick}
                />
              )}
            </div>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      sortable: true,
    },

    {
      id: 12,
      name: "PR Number",
      selector: (row) => (
        <div className="showTwoText list-item">
          <img
            style={{
              display: "block",
              margin: "auto",
              cursor: "pointer",
              width: 25,
              height: "auto",
              textTransform: "capitalize",
            }}
            data-tooltip-content="This Feature Will Be Implemented In Next iteration"
            className=" my-element"
            src={inProgress}
            alt="inProgress"
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      sortable: true,
    },
    {
      id: 13,
      name: "PO Number",
      selector: (row) => (
        <div className="showTwoText list-item">
          <img
            style={{
              display: "block",
              margin: "auto",
              cursor: "pointer",
              width: 25,
              height: "auto",
              textTransform: "capitalize",
            }}
            data-tooltip-content="This Feature Will Be Implemented In Next iteration"
            className=" my-element"
            src={inProgress}
            alt="inProgress"
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      sortable: true,
    },
  ];

  // All projects APi
  const FetchListViewProjects = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(Routes.ListViewProjects, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log("ListViewProjects--->", result);
        setProjects(result?.data[0].projects);
      })
      .catch((error) => console.log("error", error));
  };

  // filter
  const filterLength = (stage) => {
    return (
      <h2>
        {
          tableData?.filter((item) =>
            item?.stage?.toLowerCase().includes(stage)
          ).length
        }
      </h2>
    );
  };

  // Release imr request
  const FetchImrRequests = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(Routes.getRequests, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success) {
          getApproverData(result?.data);
          // setTableData(result?.data);

          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };
  const getApproverData = (data) => {
    const updatedArray = data.filter((obj) => {
      return (
        (obj.role === "Approver" && obj.stage !== "saved") ||
        obj.role === "User" ||
        (obj.role == "Viewer" && obj.stage !== "saved")
      );
    });

    setTableData(updatedArray);
  };
  useEffect(() => {
    FetchListViewProjects();
    FetchImrRequests();
    const checkIfClickedOutside = (e) => {
      if (
        editMode &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setEditMode(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [editMode]);

  const skillSelectionHandler = (skill) => {
    setSelectedSkill(skill);
    setSelectedProject(skill);
    setEditMode(false);
    setDropdownSearchValue("");
    toggleOptions();
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const handleToggle = () => {
    setVisible(false);
  };

  const handleToggle2 = () => {
    setVisible(true);
  };
  const filteredSkills = projects.filter((skill) =>
    skill.project_name.match(new RegExp(dropdownSearchValue, "i"))
  );

  // custom pagination method
  const CustomPagination2 = ({ page3, perPage3, setPage3, filteredData }) => {
    const handlePrev = () => {
      if (page3 > 0) {
        setPage3(page3 - 1);
      }
    };

    const handleNext = () => {
      if (page3 < Math.ceil(filteredData.length / perPage3) - 1) {
        setPage3(page3 + 1);
      }
    };

    // Calculate the start and end indices of the current page based on the full data array
    const startIndex = page3 * perPage3;
    const endIndex = Math.min(filteredData?.length, (page3 + 1) * perPage3);

    return (
      <div className="customPaginationMain">
        <div>
          Showing {startIndex + 1} to {endIndex} of {filteredData?.length}{" "}
          entries
        </div>
        <div className="PaginationButtonMain">
          <button className="paginationButtons" onClick={handlePrev}>
            Previous
          </button>
          {Array.from(
            { length: Math.ceil(filteredData?.length / perPage3) },
            (_, i) => {
              if (
                Math.abs(i - page3) <= 2 ||
                i === 0 ||
                i === Math.ceil(filteredData?.length / perPage3) - 1
              ) {
                // Show the current page and the two adjacent pages, or the first and last pages
                return (
                  <button
                    key={i}
                    onClick={() => setPage3(i)}
                    className={i === page3 ? "activePage" : "paginationButtons"}
                  >
                    {i + 1}
                  </button>
                );
              } else if (Math.abs(i - page3) === 3) {
                // Show an ellipsis and the last page number
                return <span key={i}>...</span>;
              } else {
                // Don't show this page number
                return null;
              }
            }
          )}
          <button className="paginationButtons" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!search && !selectedProject && !requestType && !startDate && !endDate) {
      setData(tableData);
    } else {
      let result = tableData;
      if (search) {
        result = result.filter((item) =>
          JSON.stringify(item).toLowerCase().includes(search.toLowerCase())
        );
        setData(result);
      }
      if (selectedProject) {
        setSelectedClass("");
        setSelectedShortText("");
        setSelectedMaterialCode("");
        // console.log('useEffect---->', result.map((item) => item?.projects?.project_name), selectedProject)
        result = result.filter(
          (item) => item?.projects?.project_name === selectedProject
        );
        setData(result);
      }
      if (requestType) {
        setSelectedClass("");
        setSelectedShortText("");
        setSelectedMaterialCode("");

        result = result.filter((item) => item?.stage === requestType);
        setData(result);
      }
      if (startDate && endDate) {
        result = result.filter(
          (item) =>
            new Date(item?.created_at).getTime() >= startDate.getTime() &&
            new Date(item?.created_at).getTime() <= endDate.getTime()
        );
      }
      setData(result);
    }
  }, [search, selectedProject, tableData, requestType, startDate, endDate]);

  const handleButtonClick = (type) => {
    setSelectedProject("");
    setSelectedMaterialCode("");
    setSelectedClass("");
    setSelectedShortText("");
    setPage3(0);
    if (type === null) {
      setRequestType(null);
    } else {
      setRequestType(type);
    }
    window.scrollTo(0, document.body.scrollHeight);
  };

  // Accordion Methods
  const handleMaterialCodeAccordionItemClick = (item) => {
    setSelectedMaterialCode(item);
    setSelectedClass("");
    setSelectedShortText("");
  };
  const handleShortTextAccordionItemClick = (item) => {
    setSelectedShortText(item);
    // Update state for all filters
    setSelectedMaterialCode("");
    setSelectedClass("");
  };
  const handleClassAccordionItemClick = (item) => {
    setSelectedClass(item);
    // Update state for all filters
    setSelectedMaterialCode("");
    setSelectedShortText("");
  };

  const handleEditClick = (rowId) => {
    setEditingRowId(rowId);
  };

  const EditButton = ({ row, editingRowId, handleEditClick }) => {
    const isEditable =
      (row?.stage === "saved" || row?.stage === "Returned") &&
      row?.role === "User";

    if (!isEditable) {
      return (
        <div>
          <img
            style={{ width: "25px" }}
            className="editImageIcon"
            src={editImagedisable}
            alt="editImagedisable"
          />
        </div>
      ); // Return null to render nothing
    }

    if (editingRowId === row.id) {
      return (
        <div>
          <img
            data-tooltip-content="Edit Request"
            className="editImageIcon my-element"
            onClick={() => handleClick(1, 2, row)}
            src={editImage}
            alt="editImage"
          />
        </div>
      );
    } else {
      return (
        <div>
          <img
            data-tooltip-content="Edit Request"
            className="editImageIcon my-element"
            onClick={() => handleClick(1, 2, row)}
            src={editImage}
            alt="editImage"
          />
        </div>
      );
    }
  };

  useEffect(() => {
    if (selectedRow) {
      setEditedRow(selectedRow);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (selectedRow2) {
      setEditedRow2(selectedRow2);
    }
  }, [selectedRow2]);
  const authModal = secureLocalStorage.getItem("authModal");
  if (authModal) {
    return <UnAuthModal />;
  }
  return (
    <div className="imrScreenMain">
      <div>
        <Header data={true} />
      </div>
      <div className="container-fluid mt-5 mb-5">
        <div className=" imrListMain">
          <div className=" align-items-center bd-highlight w-100 ">
            <ul className="nav nav-pills w-100" id="pills-tab" role="tablist">
              <li className="nav-item2" role="presentation">
                <button
                  onClick={() => handleToggle()}
                  className="lofimr nav-link active w-100"
                  id="pills-imr-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-imr"
                  type="button"
                  role="tab"
                  aria-controls="pills-imr"
                  aria-selected="true"
                >
                  List of IMRs
                </button>
              </li>
              <div className="col-auto secondTabPills">
                <li className="" role="presentation">
                  <Link style={{ textDecoration: "none" }} to={"/isr-list"}>
                    <button
                      onClick={() => handleToggle2()}
                      className="lofisr nav-link w-100"
                      id="pills-isr-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-isr"
                      type="button"
                      role="tab"
                      aria-controls="pills-isr"
                      aria-selected="false"
                    >
                      List of ISRs
                    </button>
                  </Link>
                </li>
              </div>
            </ul>
          </div>
        </div>

        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-imr"
            role="tabpanel"
            aria-labelledby="pills-imr-tab"
            tabindex="0"
          >
            <div class="d-flex flex-wrap imrIsrCards justify-content-start mt-5">
              <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 p-2">
                <div class="card card-imr imr-card1 text-bg-primary">
                  <div class="card-body card-body-imr">
                    <div class="row align-items-center">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleButtonClick(null)}
                        class="col"
                      >
                        <h2>{tableData.length}</h2>
                        <div class="cardText">
                          <div>
                            <h5 class="imr-title">
                              All
                              <br />
                              Requests
                            </h5>
                          </div>
                          <img
                            src={allrequest}
                            class="imr-card-img"
                            alt="..."
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 p-2">
                <div class="card card-imr imr-card2 text-bg-primary">
                  <div class="card-body card-body-imr">
                    <div class="row align-items-center">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleButtonClick("saved")}
                        class="col"
                      >
                        {filterLength("saved")}

                        <div class="cardText">
                          <div>
                            <h5 class="imr-title">
                              Saved
                              <br />
                              Requests
                            </h5>
                          </div>
                          <img src={cardimg2} class="imr-card-img" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 p-2">
                <div class="card card-imr imr-card3 text-bg-primary">
                  <div class="card-body card-body-imr">
                    <div class="row align-items-center">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleButtonClick("pending")}
                        class="col"
                      >
                        {filterLength("pending")}
                        <div class="cardText">
                          <div>
                            <h5 class="imr-title">
                              Pending
                              <br />
                              Requests
                            </h5>
                          </div>
                          <div className="pt-4">
                            <FaUserClock fontSize={"50px"} />
                          </div>
                          {/* <img src={} class="imr-card-img" alt="..." /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 p-2">
                <div class="card card-imr imr-card4 text-bg-primary">
                  <div class="card-body card-body-imr">
                    <div class="row align-items-center">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleButtonClick("Approved")}
                        class="col"
                      >
                        {filterLength("approved")}
                        <div class="cardText">
                          <div>
                            <h5 class="imr-title">
                              Requests
                              <br />
                              Approved
                            </h5>
                          </div>
                          <img src={cardimg3} class="imr-card-img" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 p-2">
                <div class="card card-imr imr-card5 text-bg-primary">
                  <div class="card-body card-body-imr">
                    <div class="row align-items-center">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleButtonClick("Rejected")}
                        class="col"
                      >
                        {filterLength("reject")}
                        <div class="cardText">
                          <div>
                            <h5 class="imr-title">
                              Requests
                              <br />
                              Rejected
                            </h5>
                          </div>
                          <img src={cardimg4} class="imr-card-img" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 p-2">
                <div class="card card-imr imr-card6 text-bg-primary">
                  <div class="card-body card-body-imr">
                    <div class="row align-items-center">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleButtonClick("Returned")}
                        class="col"
                      >
                        {filterLength("returned")}
                        <div class="cardText">
                          <div>
                            <h5 class="imr-title">
                              Requests
                              <br />
                              Returned
                            </h5>
                          </div>
                          <div className="pt-4">
                            <BsPersonFillDown fontSize={"50px"} />
                          </div>
                          {/* {console.log(data)} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="imr-list-table">
              <div className="container">
                <div className="row list-imr-text">
                  <h4 className="list-imr-text col-md-3"> List of IMRs</h4>
                </div>
                <div className="row TableRowImr">
                  <div className="col-md-6">
                    <div className="row g-2  align-items-center">
                      <div className="col-auto">
                        <div className="custom-select-isr" ref={dropdownRef}>
                          <div
                            className="selected-option-isr "
                            onClick={toggleOptions}
                          >
                            {selectedOption ? (
                              <div className="option-isr">
                                <span>{selectedOption.name}</span>
                              </div>
                            ) : (
                              <span>
                                {selectedSkill
                                  ? selectedSkill
                                  : "Select a Project"}{" "}
                              </span>
                            )}
                            <i
                              className={`fas ${
                                showOptions
                                  ? "fa-solid fa-caret-up"
                                  : "fa-solid fa-caret-down"
                              }`}
                            ></i>
                          </div>
                          {showOptions && (
                            <div>
                              <div className="options-isr">
                                <table>
                                  <thead>
                                    <tr className="HeaderDropDown-isr">
                                      {" "}
                                      <div>
                                        <img
                                          className="img-search-imr"
                                          src={searchimg}
                                        />
                                        <input
                                          className={`${
                                            editMode
                                              ? "dropdown-input-search-imr"
                                              : "dropdown-input-search-imr"
                                          } ${
                                            !(
                                              dropdownSearchValue ||
                                              selectedSkill
                                            ) && "default"
                                          }`}
                                          name="dropdown-input"
                                          autoFocus={editMode}
                                          data-bs-toggle={
                                            editMode ? "dropdown" : ""
                                          }
                                          aria-expanded={
                                            editMode ? "false" : ""
                                          }
                                          placeholder="search"
                                          onChange={(e) =>
                                            setDropdownSearchValue(
                                              e.target.value
                                            )
                                          }
                                          value={dropdownSearchValue}
                                        />
                                      </div>
                                    </tr>
                                  </thead>
                                  <tbody className="map-body-imr ">
                                    {filteredSkills.length > 0 ? (
                                      filteredSkills.map((skill) => {
                                        return (
                                          <li
                                            className="map-list-items border-top"
                                            key={skill}
                                            onClick={() => {
                                              skillSelectionHandler(
                                                skill.project_name
                                              );
                                              toggleOptions(); // add this line to close the dropdown menu
                                            }}
                                          >
                                            {skill.project_name}{" "}
                                          </li>
                                        );
                                      })
                                    ) : (
                                      <p className="text-center mt-3">
                                        No data Found
                                      </p>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-auto">
                        <div className="dropdown">
                          <button
                            className="btn btn-secondary dropdown-toggle m-0"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                            aria-expanded="false"
                          >
                            {startDate
                              ? startDate.toLocaleDateString()
                              : "From Date"}
                          </button>
                          <ul className="dropdown-menu ">
                            <li>
                              {" "}
                              <DatePicker
                                className="datepicker-imr-dropdown"
                                dateFormat="d-MMM-yyyy"
                                placeholderText="Click to select a date"
                                selected={startDate}
                                selectsStart
                                fixedHeight
                                onChange={(date) => setStartDate(date)}
                                formatWeekDay={formatWeekDay}
                                shouldCloseOnSelect={false}
                                isClearable={true}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-auto">
                        <div className="dropdown-imr">
                          <button
                            className="btn btn-secondary dropdown-toggle m-0"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                            aria-expanded="false"
                          >
                            {endDate
                              ? endDate.toLocaleDateString()
                              : "End Date"}
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <DatePicker
                                placeholderText="Click to select a date"
                                selected={endDate}
                                selectsEnd
                                fixedHeight
                                minDate={startDate}
                                isClearable={true}
                                onChange={(date) => setEndDate(date)}
                                formatWeekDay={formatWeekDay}
                                shouldCloseOnSelect={false}
                                dateFormat="d-MMM-yyyy"
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="custonDropdownIsr">
                      <div className="col-auto">
                        <div className="dropdown-center">
                          <i
                            className="imr-filter-btn d-inine-block"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-boundary="window"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-bs-auto-close="outside"
                          >
                            <img
                              src={filterSvg}
                              className="imr-filter-img"
                              height={17}
                              width={26}
                            />
                            <span className="name-filter">Filter</span>
                          </i>

                          <ul
                            className="dropdown-menu filterDropdown"
                            aria-labelledby="dropdownMenuLink"
                          >
                            <li>
                              <div
                                className="accordion accordion-flush"
                                id="accordionFlushExample"
                              >
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingOne"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseOne"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseOne"
                                    >
                                      Request Number
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseOne"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingOne"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${
                                          isOpen ? "is-open" : ""
                                        }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {data
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.request_number &&
                                                      t.request_number ===
                                                        item.request_number
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className="accordionlistItem"
                                                  key={item.request_number}
                                                  onClick={() =>
                                                    handleMaterialCodeAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.request_number}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingTwo"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseTwo"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseTwo"
                                    >
                                      Role
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingTwo"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${
                                          isOpen ? "is-open" : ""
                                        }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {data
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.role &&
                                                      t.role === item.role
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className="accordionlistItem"
                                                  key={item.role}
                                                  onClick={() =>
                                                    handleClassAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.role}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingThree"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseThree"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseThree"
                                    >
                                      Status
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingThree"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${
                                          isOpen3 ? "is-open" : ""
                                        }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {data
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.stage &&
                                                      t.stage === item.stage
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className={`accordionlistItem ${
                                                    selectedOption3 ===
                                                    item.stage
                                                      ? "selected"
                                                      : ""
                                                  }`}
                                                  key={item.class}
                                                  onClick={() =>
                                                    handleShortTextAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.stage}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-auto">
                        <div className="searchresultHeader-imr">
                          Search:
                          <input
                            type="text"
                            onChange={(e) => setSearch(e.target.value)}
                            className="SearchResult"
                          />
                        </div>
                      </div>

                      <div className="col-auto">
                        <CSVLink
                          data={data.map((row) => ({
                            Project: row?.projects?.project_name,
                            "IMR No": row?.request_number,
                            "IMR Date": moment(row?.created_at).format(
                              "DD-MM-YYYY"
                            ),

                            "Released by": row?.released_by?.first_name
                              ? row?.released_by?.first_name +
                                row?.released_by?.last_name
                              : "",
                            "Acting as": row?.role,
                            "Released Date": row?.released_date
                              ? moment(row?.released_date).format("DD-MM-YYYY")
                              : "",

                            "Required Delivery Date": row?.material
                              ?.delivary_date
                              ? row.material.delivary_date
                              : "No date found",
                            Status: row?.stage,
                          }))}
                          filename={"Imr-Report.csv"}
                        >
                          <img
                            data-tooltip-content="Download Excel"
                            className="imr-list-xls my-element"
                            src={excelfile}
                          />
                        </CSVLink>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="datatable-imr large-table">
                  {loading ? (
                    <div className="loaderScreen">
                      <Puff
                        height={80}
                        width={80}
                        color="rgba(0, 120, 207, 1)"
                        ariaLabel="puff-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    </div>
                  ) : (
                    <DataTable
                      sortIcon={
                        <div className="sort-icon">
                          {customSortIcon(sortDirection)}
                        </div>
                      }
                      onSort={handleSort}
                      sortColumn={sortColumn}
                      sortDirection={sortDirection}
                      striped
                      responsive
                      columns={columns2}
                      data={data
                        ?.filter(
                          (item) =>
                            (!selectedMaterialCode ||
                              item.request_number ===
                                selectedMaterialCode.request_number) &&
                            (!selectedClass ||
                              item.role === selectedClass.role) &&
                            (!selectedShortText ||
                              item.stage === selectedShortText.stage)
                        )
                        ?.slice(page3 * perPage3, (page3 + 1) * perPage3)}
                      // data={data.length > 10 ?
                      //   search ? data : data?.filter(
                      //     (item) =>
                      //       (!selectedMaterialCode ||
                      //         item.request_number ===
                      //         selectedMaterialCode.request_number) &&
                      //       (!selectedClass ||
                      //         item.role === selectedClass.role) &&
                      //       (!selectedShortText ||
                      //         item.stage === selectedShortText.stage)
                      //   )
                      //   :
                      //   data.slice(
                      //     page3 * perPage3,
                      //     (page3 + 1) * perPage3
                      //   )
                      // }
                      pagination
                      fixedHeader
                      onRowClicked={() => setShowTableTwo(true)}
                      fixedHeaderScrollHeight="450px"
                      highlightOnHover
                      value={data}
                      paginationComponent={() => (
                        <CustomPagination2
                          page3={page3}
                          perPage3={perPage3}
                          setPage3={setPage3}
                          filteredData={data?.filter(
                            (item) =>
                              (!selectedMaterialCode ||
                                item.request_number ===
                                  selectedMaterialCode.request_number) &&
                              (!selectedClass ||
                                item.role === selectedClass.role) &&
                              (!selectedShortText ||
                                item.stage === selectedShortText.stage)
                          )}
                        />
                      )}
                      paginationPerPage={perPage3}
                      paginationResetDefaultPage={true}
                      paginationPage={page3}
                      onChangePage={(p) => setPage3(p)}
                      onChangeRowsPerPage={(pp) => setPerPage3(pp)}
                    />
                  )}
                </div>
                <Modal isOpen={isOpen} className="modaliMRiSRList">
                  <img
                    className="close-button"
                    onClick={handleCloseModal2}
                    src={closeModal}
                    alt="closeModal"
                  />
                  <h2>
                    Do you want to initiate cancellation of the IMR,
                    ASR-1000001?
                  </h2>
                  <label className="remarks">Remarks</label>
                  <h6
                    style={{
                      color: "#0078CF",
                      textTransform: "capitalize",
                      fontWeight: "700",
                      fontSize: 18,
                    }}
                    className="text-center"
                  >
                    Note: This feature will be implemented in next iteration
                  </h6>
                  <textarea id="remarks"></textarea>
                  <div className="button-container">
                    <button disabled onClick={handleCloseModal} className="yes">
                      Yes
                    </button>
                    <button disabled onClick={handleCloseModal2} className="no">
                      No
                    </button>
                  </div>
                </Modal>
              </div>
            </div>
          </div>

          <div className="tab-pane fade">
            <div className="container-fluid ">
              <div className="row d-flex flex-wrap justify-content-center">
                <div className="col-auto bd-highlight">
                  <div className="imr-card1 card  text-bg-primary mb-3">
                    <div className="card-body card-body-imr">
                      <h5 className="row imr-title ">
                        My
                        <br />
                        Requests
                        <img
                          src={cardimg1}
                          className="imr-card-img"
                          alt="..."
                        />
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-auto bd-highlight">
                  <div className="imr-card2 card card-imr text-bg-primary mb-3">
                    <div className="card-body card-body-imr">
                      <h5 className=" row imr-title">
                        Saved <br /> Requests
                        <img
                          src={cardimg2}
                          className="imr-card-img"
                          alt="..."
                        />
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-auto bd-highlight">
                  <div className="imr-card3 card card-imr text-bg-primary mb-3">
                    <div className="card-body card-body-imr">
                      <h5 className="row imr-title ">
                        Pending
                        <br />
                        Requests
                        <img
                          src={cardimg2}
                          className="imr-card-img"
                          alt="..."
                        />
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-auto bd-highlight">
                  <div className="imr-card4 card card-imr text-bg-primary mb-3">
                    <div className="card-body card-body-imr">
                      <h5 className="row imr-title ">
                        Requests
                        <br /> Approved
                        <img
                          src={cardimg3}
                          className="imr-card-img"
                          alt="..."
                        />
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-auto bd-highlight">
                  <div className="imr-card5 card card-imr text-bg-primary mb-3">
                    <div className="card-body card-body-imr">
                      <h5 className="row imr-title ">
                        Requests <br /> Rejected
                        <img
                          src={cardimg4}
                          className="imr-card-img"
                          alt="..."
                        />
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-auto bd-highlight">
                  <div className="imr-card6 card card-imr text-bg-primary mb-3 ">
                    <div className="card-body card-body-imr">
                      <h5 className="row imr-title ">
                        Request <br /> Returned
                        <img
                          src={cardimg2}
                          className="imr-card-img"
                          alt="..."
                        />
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Tooltip anchorSelect=".my-element" type="dark" effect="solid" />

      <Footer />
    </div>
  );
};

export default ImrList;
